
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registration/foodie",
      function () {
        return require("private-next-pages/registration/foodie/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registration/foodie"])
      });
    }
  